// Core packages
import { NgModule } from "@angular/core";

// Third party packages

// Custom packages - Modules
import { DocumentArchiveDownloadDialogModule } from "src/app/modules/properties/document-archive-download-dialog.module";
import { SharedModule } from "src/app/modules/shared.module";

// Custom packages - Components
import { MappingArchiveDocsDialogComponent } from "src/app/modules/properties/components/mapping-archive-docs-dialog/mapping-archive-docs-dialog.component";

/**
 * The dialog of the mapping tab that lists the documents of an element on the 3.0.0 archive, before
 * «Rifare impianto» and «Elimina impianto» / «Elimina la scheda» (MAP-A1), with the «Scarica i
 * documenti» dialog it opens.
 *
 * Imported by PropertiesModule, where the mapping tab is: before Ivy a dialog is resolved by the
 * injector of the module that opens it. That puts it in the initial bundle — the price of opening it
 * from a page that is there.
 *
 * @since 3.0.0
 */
@NgModule({
  imports: [SharedModule, DocumentArchiveDownloadDialogModule],
  declarations: [MappingArchiveDocsDialogComponent],
  entryComponents: [
    // Pre-Ivy requirement: the dialog is created at runtime by MatDialog
    MappingArchiveDocsDialogComponent,
  ],
})
export class MappingArchiveDocsDialogModule {}
